<footer id="footer">
    <ul class="icons">
        <li><a href="http://twitter.com/5ASideTheatre" class="icon brands alt fa-twitter" target="_blank"><span class="label">Twitter</span></a></li>
        <li><a href="#" class="icon brands alt fa-facebook-f" target="_blank"><span class="label">Facebook</span></a></li>
        <li><a href="http://www.instagram.com/fiveasideTheatre/" class="icon brands alt fa-instagram" target="_blank"><span class="label">Instagram</span></a></li>
    </ul>
    <ul class="copyright">
        <li>&copy; Five-A-Side Theatre. All rights reserved.</li><li>Developed / Designed: <a href="http://conwayalphonso.com">Conway Alphonso Digital</a></li>
    </ul>
</footer>
